import { Checkbox, Form, FormInstance, Modal } from "antd";
import React from "react";
import { ExtraFieldModalContent } from "./modal-content";
import { css } from "@emotion/react";
import { FilterFormFieldsEnum } from "@src/pages/ab-test-explore/enum";
import { ALL_EXTRA_FIELDS_AS_DATE, ALL_EXTRA_FIELDS_FILTER } from "@src/pages/ab-test-explore/contanst/filter-fields";
import { ExtraButton } from "./extra-button";
import { ModalFooter } from "./modal-footer";
import { convertDateRangeToDayJS } from "@src/util/time-form";
import { useTracking } from "react-tracking";
import { trackEventPayload } from "@src/util/track-event-payload";

export const ExtraFilterMain: React.FC<{ form: FormInstance }> = ({ form }) => {
  const { trackEvent } = useTracking();
  const isModalOpen = Form.useWatch(FilterFormFieldsEnum.IS_OPEN_MODAL, form);

  const handleWhenModalOpen = (_open: boolean) => {
    if (!_open) {
      trackEvent(trackEventPayload.extraFieldFilter("modal_close", {}));
      return;
    }
    trackEvent(trackEventPayload.extraFieldFilter("modal_open", {}));
    const extraFilerValuesConfirmed = form.getFieldValue(FilterFormFieldsEnum.EXTRA_FILTER_VALUES_CONFIRMED);
    const extraFilerValuesConfirmedParsed = JSON.parse(extraFilerValuesConfirmed ?? "{}");

    if (extraFilerValuesConfirmed === undefined) return;
    const valuesExtraForm: Record<string, any> = {};
    ALL_EXTRA_FIELDS_FILTER.forEach((field) => {
      if (ALL_EXTRA_FIELDS_AS_DATE.includes(field)) {
        valuesExtraForm[field] = convertDateRangeToDayJS(extraFilerValuesConfirmedParsed[field]);
      } else {
        valuesExtraForm[field] = extraFilerValuesConfirmedParsed[field];
      }
    });
    form.setFieldsValue({
      ...valuesExtraForm,
      [FilterFormFieldsEnum.EXTRA_PLATFORM]: form.getFieldValue(FilterFormFieldsEnum.PLATFORM),
      [FilterFormFieldsEnum.EXTRA_VARIANTS]: form.getFieldValue(FilterFormFieldsEnum.VARIANTS),
    });
  };

  return (
    <>
      <Form.Item className="pt-7">
        <ExtraButton form={form} />
      </Form.Item>
      <Modal
        css={css`
          .ant-modal-content {
            padding: 0;
          }
        `}
        style={{ maxWidth: 1400 }}
        title={<div className="bg-blue-700 text-white p-4 rounded-t-[6px]">Extra general info filter</div>}
        footer={() => {
          return <ModalFooter form={form} />;
        }}
        width={"90%"}
        open={isModalOpen}
        centered
        onCancel={() => {
          form.setFieldsValue({
            [FilterFormFieldsEnum.IS_OPEN_MODAL]: false,
            [FilterFormFieldsEnum.EXTRA_PLATFORM]: form.getFieldValue(FilterFormFieldsEnum.PLATFORM),
            [FilterFormFieldsEnum.EXTRA_VARIANTS]: form.getFieldValue(FilterFormFieldsEnum.VARIANTS),
          });
          trackEvent(
            trackEventPayload.extraFieldFilter("button_click", {
              button_name: "cancel",
            }),
          );
        }}
        afterOpenChange={handleWhenModalOpen}
      >
        <div className="px-4 ">
          <ExtraFieldModalContent form={form} />
        </div>
      </Modal>
      <Form.Item name={FilterFormFieldsEnum.IS_SHOW_CHIP} hidden valuePropName="checked">
        <Checkbox />
      </Form.Item>
      <Form.Item name={FilterFormFieldsEnum.IS_OPEN_MODAL} hidden valuePropName="checked">
        <Checkbox />
      </Form.Item>
    </>
  );
};
